module.exports = __webpack_public_path__ + "deb47290aa86f2faa1e01845bb8a7a38.svg";